import PropTypes from 'prop-types'
import React from 'react'

import './DisableableWrapper.less'

import classNames from 'classnames'

const COMPONENT_CLASS = 'disableable-wrapper'

class DisableableWrapper extends React.Component {
  isDisabled () {
    return this.props.hasOwnProperty('disabled') && this.props.disabled !== false
  }

  render () {
    const classes = classNames(COMPONENT_CLASS, {
      'is-disabled': this.isDisabled()
    })
    return (
      <div className={classes}>
        {this.props.children}
      </div>
    )
  }
}

DisableableWrapper.DEFAULT_CLASS = COMPONENT_CLASS

DisableableWrapper.propTypes = {
  disabled: PropTypes.bool
}

export default DisableableWrapper



// WEBPACK FOOTER //
// ../~/@master/webinfra-frontend-components/src/components/DisableableWrapper/index.js